import { Pie } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import React from 'react';

import {
  Container,
} from './styles';

const PieChart = (props) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      animateScale: true,
    },
    legend: {
      position: 'right',
      labels: {
        boxWidth: 15,
      },
    },
  };

  return (
    <Container>
      <Pie
        data={props.data}
        options={options}
        height={150}
      />
    </Container>
  );
};

PieChart.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PieChart;
